module.exports = __webpack_public_path__ + "static/media/noun-information-1281661-142350-small.5757263b.svg";